module.exports = __webpack_public_path__ + "img/logo.f81a4f2d.png";